import { Form, Input } from 'antd';

const { TextArea } = Input;

export const ValidatedFormItem = ({
    name,
    label,
    placeholder,
    required = false,
    disabled,
    inputType = 'textarea',
    errorMessage,
    ...rest
}) => {
    const validateInput = (_, value) => {
        if (!value) {
            return Promise.resolve();
        }

        // Разрешенные символы: кириллица, латиница, цифры, пробелы, тире, дефис, запятая, точка, скобки, спецсимволы (!"№;%:?* ' `~@#^&_=+{[]}|/<>)
        // Все остальное запрещено
        const invalidCharsRegex = /[^a-zA-Z0-9а-яА-ЯёЁіІїЇєЄґҐ\s\-\—\–\,\.\(\)\!\"№\;\%\:\?\*\'\`\~\@\#\^\&\_\=\+\{\[\]\}\|\/\<\>]/;

        if (invalidCharsRegex.test(value)) {
            return Promise.reject(
                new Error(
                    'Недопустимі символи. Дозволено: літери, цифри, знаки пунктуації та спецсимволи'
                )
            );
        }

        return Promise.resolve();
    };

    return (
        <Form.Item
            name={name}
            label={label}
            rules={[
                {
                    required: required,
                    message: errorMessage || `Вкажіть ${typeof label === 'string' ? label.toLowerCase() : 'значення'}`,
                },
                { validator: validateInput },
            ]}
            {...rest}
        >
            {inputType === 'input' ? (
                <Input placeholder={placeholder} disabled={disabled} />
            ) : (
                <TextArea placeholder={placeholder} disabled={disabled} />
            )}
        </Form.Item>
    );
};

export const RequestComments = (props) => (
    <ValidatedFormItem name="Symptoms" inputType="textarea" {...props} />
);
